import styled from 'styled-components';

import { StyledCardWrapperWithState } from '@/components';
import { colors, responsive } from '@/utils';

export const ImageGalleryStyledWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  grid-auto-rows: minmax(15rem, 19rem);
  gap: ${responsive.spacing.large};
  width: 100%;
`;

export const StyledImageCard = styled(StyledCardWrapperWithState)`
  overflow: hidden;
  background-color: ${colors.palette.neutral.dark['700']};
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
